import { render, staticRenderFns } from "./roster-sync-view.vue?vue&type=template&id=2bede30c&scoped=true&"
import script from "./roster-sync-view.ts?vue&type=script&lang=ts&"
export * from "./roster-sync-view.ts?vue&type=script&lang=ts&"
import style0 from "./roster-sync-view.scss?vue&type=style&index=0&id=2bede30c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bede30c",
  null
  
)

export default component.exports